export const DATA_STORE_KEYS = {
    // Local Storage Keys
    DEVICE_ID: 'deviceId',
    USER_DATA: 'user_data',
    USER_CURRENT_ROLE: 'user_current_role',

    // Session Storage Keys
    IS_SESSION_INIT: 'is_session_init',

    // Cookies Keys
    RECAPTCHA_STATUS: 'GRC_STATUS',
    RECAPTCHA_RESPONSE_DATA: 'responsedata',
    GRC_TOKEN: 'GRC_TOKEN',
    GRC_ACTION: 'GRC_ACTION',
    GRC_CHALLENGE: 'GRC_CHALLENGE',

    // Common Keys
    IS_LOGGEDIN: 'is_loggedin',
    CISCO_AUTH_TOKEN: '_cisco.auth_token',
    USER_EMPLOYEE: 'user_employee',
    DIRECTION: 'direction',
    USER: 'user',
};
